module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('div', {
    staticClass: "p-br"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("When Marco Polo lay on his deathbed,"), _c('br'), _vm._v(" his priest, his friends and relations"), _c('br'), _vm._v(" clustered around him to plead that he"), _c('br'), _vm._v(" at last renounce the countless lies he"), _c('br'), _vm._v(" had related as his true adventures, so his"), _c('br'), _vm._v(" soul would go cleansed to Heaven. The"), _c('br'), _vm._v(" old man raised up, roundly damned them"), _c('br'), _vm._v(" all and declared, “I have not told"), _c('br'), _vm._v(" the half of what I saw and did!”")])])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACCORDING TO")]), _vm._v(" "), _c('br'), _c('strong', {
    staticClass: "b"
  }, [_vm._v("FRA JACOPO D’ACQUI,")]), _vm._v(" "), _c('br'), _c('strong', {
    staticClass: "b"
  }, [_vm._v("MARCO POLO’S CONTEMPORARY")]), _vm._v(" "), _c('br'), _c('strong', {
    staticClass: "b"
  }, [_vm._v("AND HIS FIRST BIOGRAPHER")])])])]), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f1f4205","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429999946_fm02.vue
// module id = 66
// module chunks = 0